<template>
  <path
    d="M3 17.4603V20.5003C3 20.7803 3.22 21.0003 3.5 21.0003H6.54C6.67 21.0003 6.8 20.9503 6.89 20.8503L17.81 9.9403L14.06 6.1903L3.15 17.1003C3.05 17.2003 3 17.3203 3 17.4603ZM20.71 7.0403C21.1 6.6503 21.1 6.0203 20.71 5.6303L18.37 3.2903C17.98 2.9003 17.35 2.9003 16.96 3.2903L15.13 5.1203L18.88 8.8703L20.71 7.0403Z"
  />
</template>
